import React from 'react';
import PropTypes from 'prop-types';
import { Pagination, Button } from 'antd';
import { faChevronLeft, faChevronRight } from '@fortawesome/free-solid-svg-icons';
import './Paginations.scss';
import FontIcon from './FontIcon';

const nextPrevButtons = (type) => (

    <Button>
        {type === 'prev' && <FontIcon icon={faChevronLeft} />}
        <span>{`${type === 'prev' ? '上' : '下'}一頁`}</span>
        {type === 'next' && <FontIcon icon={faChevronRight} />}
    </Button>

);

const itemRender = (page, type, originalElem) => {

    if (type === 'prev') return nextPrevButtons('prev');
    if (type === 'next') return nextPrevButtons('next');

    // Betty: 是否能簡化 fn!?

    return originalElem;

};

const showTotal = (total, range) => (`共 ${total} 筆資料，顯示第 ${range[0]}-${range[1]} 筆`);

const Paginations = ({
    total,
    pageSize,
    showPageRange,
}) => (

    <Pagination
        className="pagination"
        total={total}
        pageSize={pageSize}
        itemRender={itemRender}
        showTotal={showPageRange && showTotal}
    />

);

Paginations.defaultProps = {
    pageSize: 20,
    showPageRange: true,
};

Paginations.propTypes = {
    total: PropTypes.number.isRequired,
    pageSize: PropTypes.number,
    showPageRange: PropTypes.bool,
};

export {
    Paginations as default,
    itemRender,
    showTotal,
};
